import {APIClient} from "@crunchyroll/cx-api-client-lite";

/**
 * @typedef {function(payload: {}=): Promise<{data: {}, headers: {}, status: Number}>} ApiMethod
 */
/**
 * @typedef {Object} ContentAPIClient
 *
 * @description Use the following prefix in the method naming: POST -> create; GET -> get; DELETE -> delete; PATCH, PUT -> update;
 *
 * @property {ApiMethod} getObjects
 */
/**
 * @type {ContentAPIClient & APIClient}
 */
const Content = new APIClient({
  getObjects: {
    path: "/content/v2/cms/objects/{contentIds}",
    method: "GET",
  },
  getSimilarTo: {
    path: `/content/v2/discover/similar_to/{guid}`,
    method: "GET",
  },
});

export default Content;
